import { render, staticRenderFns } from "./gamePaybackList.vue?vue&type=template&id=eb82a880&scoped=true"
import script from "./gamePaybackList.vue?vue&type=script&lang=js"
export * from "./gamePaybackList.vue?vue&type=script&lang=js"
import style0 from "./gamePaybackList.vue?vue&type=style&index=0&id=eb82a880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb82a880",
  null
  
)

export default component.exports